import GetFieldsDescription from '../../utils/GetFieldsDescription';
import log from '../../utils/log';
import gsap from 'gsap';

const updateDescriptionsOnDOM = (fields, values, rules) => {
  const descriptions2Display = GetFieldsDescription({
    fields,
    rules,
    values,
    includeId: true
  });

  Object.entries(descriptions2Display).forEach(([fieldId, descriptionNode]) => {
    const fieldNode = document.querySelector(`[field-id='${fieldId}']`);

    if (!fieldNode) {
      log(
        `Couldn't find field with id ${fieldId}, description logic may be affected!`
      );
      return;
    }

    const descriptions = fieldNode.querySelectorAll(
      `[data-type='description']`
    );

    descriptions.forEach(d => {
      // hide hidden description:
      if (d.getAttribute('data-id') !== descriptionNode.id) {
        if (d.style.display === 'none') {
          return;
        }
        gsap.to(d, {
          duration: 0,
          height: 0,
          autoAlpha: 0,
          display: 'none'
        });
      } else if (d.style.display === 'none') {
        // show non-hidden description
        gsap.set(d, { height: 'auto', display: 'block' });

        gsap.fromTo(
          d,
          {
            autoAlpha: 0
          },
          {
            duration: 0.3,
            autoAlpha: 1
          }
        );
      }
    });
  });
};

export const initFieldDescriptionsOnDOM = (fields, values, rules) => {
  const descriptions2Display = GetFieldsDescription({
    fields,
    rules,
    values,
    includeId: true
  });

  Object.entries(descriptions2Display).forEach(([fieldId, descriptionNode]) => {
    const fieldNode = document.querySelector(`[field-id='${fieldId}']`);

    if (!fieldNode) {
      log(
        `Couldn't find field with id ${fieldId}, description logic may be affected!`
      );
      return;
    }

    const descriptions = fieldNode.querySelectorAll(
      `[data-type='description']`
    );

    descriptions.forEach(d => {
      if (d.getAttribute('data-id') !== descriptionNode.id) {
        d.style.display = 'none';
      }
    });
  });
};

export const initFieldDescriptions = (fields, rules = []) => {
  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i];
    if (rule.action && rule.action.actionType !== 'description') {
      continue;
    }

    const targetField = fields.find(f => f.internalId === rule.fieldId);
    if (!targetField) {
      continue;
    }

    let descriptionsNodes = [];
    try {
      descriptionsNodes = JSON.parse(rule.condition);
    } catch (e) {
      log(e);
      continue;
    }

    targetField.description = descriptionsNodes.map(dN => ({
      description: dN.description,
      id: dN._id
    }));
  }
};

export default updateDescriptionsOnDOM;
